import useLocalStorage from './use-local-storage';
import {StepStatus} from '../app/gakki/context/app-context';
import {DateTime} from 'luxon';
import {toast} from 'react-toastify';

function usePageData<T>(pageName: string, initialData: T) {
  const names = {
    data: `${pageName}-data`,
    status: `stepStatus`,
    updatedTime: `${pageName}-updatedTime`,
  };
  const [data, setData] = useLocalStorage<T>(names.data, initialData);
  const [status, setStatus] = useLocalStorage<StepStatus>(
    names.status,
    StepStatus.init,
  );
  const [updatedTime, setUpdatedTime] = useLocalStorage<string>(
    names.updatedTime,
    '',
  );

  return {
    data,
    setData: (data: T, status?: StepStatus) => {
      if (status) {
        if (status === StepStatus.updated) {
          setUpdatedTime(DateTime.now().toFormat('yyyy/MM/dd HH:mm'));
        }
        setStatus(status);
      }
      if (data !== initialData && status === undefined) {
        setStatus(StepStatus.edit);
      }

      setData(data);
    },
    status,
    setStatus: (status: StepStatus) => {
      if (status && status === StepStatus.updated) {
        setUpdatedTime(DateTime.now().toFormat('yyyy/MM/dd HH:mm'));
      }
      setStatus(status);
    },
    updatedTime,
    setUpdatedTime,
    remove: () =>
      Object.values(names).forEach(n => window.localStorage.removeItem(n)),
    init: (pageData: T) => {
      setData(pageData);
      setStatus(StepStatus.init);
    },
    edit: (pageData: T) => {
      setData(pageData);
      setStatus(StepStatus.edit);
    },
    update: () => {
      toast.success('儲存成功', {
        hideProgressBar: true,
        position: 'top-center',
      });
      setStatus(StepStatus.updated);
      setUpdatedTime(DateTime.now().toFormat('yyyy/MM/dd HH:mm'));
    },
  };
}

export default usePageData;
